import React from 'react';
import Grid from '@material-ui/core/Grid';
import i18next from 'i18next';

import { useSelector } from 'react-redux';
import TextInput from '~/components/TextInput';
import TextArea from '~/components/TextArea';

import OutlineButton from '~/components/Button/MainButtons/Outline';
import { Container, Header, Title, NoData } from './styles';
import { IconEdit } from '../Threats/styles';

const Impact = () => {
  const { riskDetails } = useSelector((state) => state.risks);

  return (
    <Container>
      <Header>
        <Title>
          {i18next.t(
            'risks.riskDetails.associations.impactForInoperability.title'
          )}
        </Title>
        <OutlineButton
          onClick={() => {}}
          label={i18next.t('common.buttons.edit')}
          leftIcon={<IconEdit />}
        />
      </Header>
      {riskDetails?.impacts && riskDetails.impacts.length > 0 ? (
        riskDetails.impacts.map((impact) => (
          <Grid
            key={impact.id}
            container
            spacing={4}
            style={{ marginBottom: '10rem' }}
          >
            <Grid item xs={4}>
              <TextInput
                label={i18next.t(
                  'risks.riskDetails.associations.impactForInoperability.maxTime'
                )}
                placeholder="DD/MM/AA"
                value={impact.max_stop_time}
                editable={false}
              />
            </Grid>
            <Grid item xs={3}>
              <TextInput
                label={i18next.t(
                  'risks.riskDetails.associations.impactForInoperability.impact'
                )}
                placeholder="selecionar"
                value={impact.impact}
                editable={false}
              />
            </Grid>
            <Grid item xs={5} />
            <Grid item xs={12}>
              <TextArea
                label={i18next.t(
                  'risks.riskDetails.associations.impactForInoperability.consequences'
                )}
                placeholder="Descrição aqui"
                value={impact.consequences}
                editable={false}
              />
            </Grid>
          </Grid>
        ))
      ) : (
        <NoData>{i18next.t('risks.risksTable.noData')}</NoData>
      )}
    </Container>
  );
};

export default Impact;
